import replaceLast from '../../utils/replace-last';
import placeholder from './img_placeholder.png';

function withFallback(url = '', size = 'medium') {
  const image = replaceLast(url, '.', `_${size}.`);
  return image || placeholder;
}

export default withFallback;
